// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"21":"c050af52","38":"c050af52","116":"ca5e92fe","368":"c050af52","375":"5fab6989","396":"1dd2f262","425":"ccb7e733","489":"c050af52","516":"c050af52","724":"c050af52","865":"c050af52"}[chunkId] + ".chunk.css";
};